<div class="inline-block" (window:resize)="onResize()">
  @if ($playStarted()) {
    <div
      class="absolute size-[34px] flex top-0 right-0 cursor-pointer"
      (click)="closeVideo()"
    >
      <mat-icon fontSet="fa" fontIcon="fa-times"></mat-icon>
    </div>
  }
  @if (dataIn && dataIn.src) {
    <iframe
      id="ifrvimeo"
      [class.portrait]="$portrait()"
      [src]="
        dataIn.src + '&amp;autoplay=1&amp;player_id=0&amp;app_id=58479' | safe: 'url'
      "
      frameborder="0"
      allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media"
    ></iframe>
  }
</div>
